import formElementCreator from './formElementCreator.js'
// import formModule from './formModule.js'
import cms from '../cms.js'
import xhrModule from '../xhrModule.js'
import formResourcesManager from './formResourcesManager.js'
import general from '../general.js'

var formCreator = function (options) {
	return {
		init: function () {
			this.layout = options.layout
			this.languages = options.languages
			this.instances = options.instances
			this.data = options.data
			this.container = options.container
			this.entity = options.entity

			if (this.entity) {
				this.entityProperties = options.entity.properties
				// if the entity is users or roles we can drop all other languages because we only need to post to CMS language
				if (this.entity.id === 24 || this.entity.id === 25) {
					this.languages = {
						'1': this.languages['1']
					}
				}
			} else {
				this.entityProperties = options.entityProperties
			}
			this.callback = options.callback
			this.formIsEditableReference = options.editableReference
			this.editableReferenceLang = options.currentLanguage
			this.editableRefInt = options.editableRefInt
			this.hidePassword = options.hidePassword
			this.startUniform = options.startUniform

			this.amountLanguages = Object.keys(this.languages).length
			this.amountOfElements = 0
			this.conditionalDataArr = []

			for (var el in options.data.elements) {
				var settings = options.data.elements[el].property.settings

				// do not count passwords because we don't render them
				if (this.hidePassword && settings.type.value === 'Password') continue

				// do not count multiple per language for synced fields and editable references
				if (settings.synced.value === '1' || settings.type.value === 'Editable reference') {
					this.amountOfElements++
				} else {
					this.amountOfElements = this.amountOfElements + (1 * this.amountLanguages)
				}
			}

			this.elementCounter = 0

			// normalize instances to an object
			if (Array.isArray(this.instances)) {
				if (this.instances.length === 0) {
					this.instances = null
				}
			}

			this.setupForm()
			this.renderFormElements()
		},

		setupForm: function () {
			this.langWrapper = document.createElement('div')
			this.langWrapper.classList.add('languages')
			if (!this.formIsEditableReference) this.langWrapper.classList.add('conditional-container')
			if (this.formIsEditableReference) this.langWrapper.classList.add('collapsed')

			if (!this.formIsEditableReference) {
				this.form = document.createElement('form')
				this.form.setAttribute('id', 'multilanguage')
				this.form.setAttribute('novalidate', '')

				// create form submit & cancel buttons
				var buttonWrapper = document.createElement('div')
				buttonWrapper.classList.add('btns-top')

				// var cancelButton = document.createElement('a')
				// cancelButton.setAttribute('href', '#')
				// cancelButton.className = 'btn btn-close transition-fadeinup transition-delay-01 fa fa-times'
				// buttonWrapper.appendChild(cancelButton)

				var submitButton = document.createElement('button')
				submitButton.setAttribute('type', 'submit')
				submitButton.className = 'btn btn-submit transition-fadeinup transition-delay-02 fa fa-save'
				buttonWrapper.appendChild(submitButton)

				this.form.appendChild(this.langWrapper)
				this.form.appendChild(buttonWrapper)
				if (this.container) this.container.appendChild(this.form)
			} else {
				this.container.appendChild(this.langWrapper)
			}

			if (!this.container) return

			this.createHiddenFields()

			if (this.layout === 'multiple' && !this.formIsEditableReference) {
				for (var key in this.languages) {
					// render languages title
					var div = document.createElement('div')
					div.classList.add('lang')
					div.classList.add(this.languages[key].locale)

					var title = document.createElement('h3')
					var langTitle = this.languages[key].language
					if (this.languages[key].region) langTitle = langTitle + ' (' + this.languages[key].region + ')'
					title.innerHTML = langTitle

					div.appendChild(title)
					this.langWrapper.appendChild(div)
				}

				this.createHR()

				for (var key1 in this.languages) {
					// render language toggles
					var div3 = document.createElement('div')
					div3.classList.add('lang')
					div3.classList.add('status-checkbox')
					div3.classList.add(this.languages[key1].locale)

					var button = document.createElement('a')
					button.setAttribute('href', '#')
					button.classList.add('btn-multi-switch')

					var span = document.createElement('span')
					span.innerHTML = 'Online'

					var elementName = 'lang.' + this.languages[key1].locale + '.state'
					var input = document.createElement('input')
					input.setAttribute('type', 'number')
					input.setAttribute('name', elementName)

					// set default publish value based on auto publish setting
					let autoPublish = 'false'
					if (this.entity.settings.autopublish) {
						autoPublish = this.entity.settings.autopublish.value
					}
					let publishValue = autoPublish === 'false' ? 1 : 3

					// set auto publish attribute in order for the lang switcher to know when to unpublish a new instance when the language is not active
					button.setAttribute('data-autopublish', autoPublish)

					// check the publish state of this specific instance
					if (this.instances) {
						var obj = this.getValueForThisLang(this.languages[key1].locale)
						if (obj) publishValue = obj.state
					}

					// set publish value
					input.value = publishValue

					// add visual indication of publish value
					if (publishValue === 2) {
						button.classList.add('active-step1')
					} else if (publishValue === 3) {
						button.classList.add('active-step2')
					}

					button.appendChild(span)
					button.appendChild(input)
					div3.appendChild(button)

					this.langWrapper.appendChild(div3)

					// add market data in hidden fields
					var langName = 'lang.' + this.languages[key1].locale + '.market'

					var inputMarketID = document.createElement('input')
					inputMarketID.setAttribute('type', 'hidden')
					inputMarketID.setAttribute('name', langName + '.id')
					inputMarketID.value = this.languages[key1].id

					var inputMarketLocale = document.createElement('input')
					inputMarketLocale.setAttribute('type', 'hidden')
					inputMarketLocale.setAttribute('name', langName + '.locale')
					inputMarketLocale.value = this.languages[key1].locale

					this.langWrapper.appendChild(inputMarketID)
					this.langWrapper.appendChild(inputMarketLocale)
				}

				this.createHR()
			}
		},

		createLangTitle: function (lang, key) {
			// ID for the (new) instance
			var IDField = document.createElement('input')
			IDField.setAttribute('type', 'hidden')
			var name = 'lang.' + lang.locale + '.id'
			if (this.formIsEditableReference) name = 'editableReferences.' + this.editableRefInt + '.' + name
			IDField.setAttribute('name', name)

			var value = 0
			if (this.instances) {
				var obj = this.getValueForThisLang(this.languages[key].locale)
				if (obj) value = obj.id
			}
			IDField.setAttribute('value', value)

			this.langWrapper.appendChild(IDField)
		},

		createHiddenFields: function () {
			if (this.layout === 'single') {
				this.createLangTitle(this.editableReferenceLang)
			} else {
				for (var key in this.languages) {
					this.createLangTitle(this.languages[key], key)
				}
			}

			// Entity id
			var entityIDField = document.createElement('input')
			entityIDField.setAttribute('type', 'hidden')
			var name = 'entity[id]'
			if (this.formIsEditableReference) name = 'editableReferences.' + this.editableRefInt + '.' + name
			entityIDField.setAttribute('name', name)
			entityIDField.setAttribute('value', this.data.entity.id)

			// Entity name
			var entityNameField = document.createElement('input')
			entityNameField.setAttribute('type', 'hidden')
			var name1 = 'entity[name]'
			if (this.formIsEditableReference) name1 = 'editableReferences.' + this.editableRefInt + '.' + name1
			entityNameField.setAttribute('name', name1)
			entityNameField.setAttribute('value', this.data.entity.name)

			// create UUID to link the language instances if none exists
			var UUIDField = document.createElement('input')
			UUIDField.setAttribute('type', 'hidden')
			var name2 = 'uuid'
			if (this.formIsEditableReference) name2 = 'editableReferences.' + this.editableRefInt + '.' + name2
			UUIDField.setAttribute('name', name2)

			if (this.instances) {
				// set existing UUID
				UUIDField.value = this.instances[Object.keys(this.instances)[0]].uuid
			} else {
				// generate new UUID
				formResourcesManager.incrementCallToFinish()
				var url = '/cms/api/uuid'
				xhrModule.get(url, function (data) {
					UUIDField.value = data.data
					formResourcesManager.subtractCallToFinish()
				})
			}

			this.langWrapper.appendChild(UUIDField)

			// add properties in hidden field
			var hiddenEntityProperties = document.createElement('input')
			hiddenEntityProperties.setAttribute('type', 'hidden')
			var name3 = 'entity-properties'
			if (this.formIsEditableReference) name3 = 'editableReferences.' + this.editableRefInt + '.' + name3
			hiddenEntityProperties.setAttribute('name', name3)
			hiddenEntityProperties.value = JSON.stringify(this.entityProperties)

			// add instances in hidden field
			var hiddenInstances = document.createElement('input')
			hiddenInstances.setAttribute('type', 'hidden')
			var name4 = 'instances'
			if (this.formIsEditableReference) name4 = 'editableReferences.' + this.editableRefInt + '.' + name4
			hiddenInstances.setAttribute('name', name4)
			hiddenInstances.value = JSON.stringify(this.instances)

			this.langWrapper.appendChild(entityIDField)
			this.langWrapper.appendChild(entityNameField)
			this.langWrapper.appendChild(hiddenEntityProperties)
			this.langWrapper.appendChild(hiddenInstances)
		},

		getValueForThisLang: function (locale) {
			for (var key in this.instances) {
				if (this.instances[key].market.locale === locale) {
					return this.instances[key]
				}
			}
		},

		renderFormElements: function () {
			var elements = this.data.elements

			// add translations to the form elements if they exist
			if (this.instances) elements = this.addTranslationsToForm(elements)

			// sort based on priority
			var sortedElements = []
			for (var element in elements) {
				sortedElements.push([element, elements[element]])
			}

			sortedElements.sort(function (a, b) {
				return a[1].priority - b[1].priority
			})

			// render elements
			for (var i = 0; i < sortedElements.length; i++) {
				// don't render password field when hidePassword is set to true
				if ((this.hidePassword && sortedElements[i][1].property.settings.type.value !== 'Password') || !this.hidePassword) {
					this.setupElement(sortedElements[i])
				}

				if (i === sortedElements.length - 1) {
					if (this.layout === 'multiple') {
						// run uniform and cms multilang layout
						cms.setLanguagesDimensions(this.languages)
					}
				}
			}
		},

		addTranslationsToForm: function (elements) {
			for (var key in elements) {
				var translations = elements[key]['translations'] = {}
				for (var key1 in this.instances) {
					var locale = this.instances[key1].market.locale
					if (this.instances[key1].data[key]) {
						translations[locale] = {
							'value': this.instances[key1].data[key].value
						}
					}
				}
			}

			return elements
		},

		setupElement: function (el) {
			// check if this field is synced
			this.synced = false
			if (el[1].property.settings.synced.value === '1') {
				this.synced = true
			}

			// check if this field is an editable reference
			this.editableRef = false
			if (el[1].property.settings.type.value) {
				if (el[1].property.settings.type.value === 'Editable reference') {
					this.editableRef = true
				}
			}

			if (this.layout === 'multiple') {
				if (this.synced || this.editableRef) {
					this.renderElement({
						'class': 'sync',
						'locale': '',
						'editableRef': this.editableRef,
						'element': el,
						'currentLang': null
					})
				} else {
					for (var key in this.languages) {
						this.renderElement({
							'class': 'lang',
							'locale': this.languages[key].locale,
							'editableRef': this.editableRef,
							'element': el,
							'currentLang': this.languages[key]
						})
					}
				}
			}

			this.createHR()
		},

		renderElement: function (options) {
			var conditionalFieldName = null

			var lang = options.currentLang
			if (!lang) {
				// find the default lang
				lang = general.findItemWithLowestPriority(this.languages)
			}

			for (var i = 0; i < this.conditionalDataArr.length; i++) {
				if (options.element[1].property.settings.conditional) {
					var synced = this.conditionalDataArr[i].name.indexOf('synced') > 1

					// non synced conditional parents
					if (this.conditionalDataArr[i].id == options.element[1].property.settings.conditionalParent.value && this.conditionalDataArr[i].lang == lang.id && !synced) {
						conditionalFieldName = this.conditionalDataArr[i].name
					}

					// synced conditional parents
					if (this.conditionalDataArr[i].id == options.element[1].property.settings.conditionalParent.value && synced) {
						conditionalFieldName = this.conditionalDataArr[i].name
					}
				}
			}

			// check if this is a conditional field
			var conditionalData = null
			if (options.element[1].property.settings.conditional) {
				conditionalData = {
					'conditionalValue': options.element[1].property.settings.conditional.value,
					'conditionalParent': conditionalFieldName
				}
			}

			var div = document.createElement('div')
			div.classList.add(options.class)
			if (options.locale) div.classList.add(options.locale)

			if (conditionalData) {
				var formattedValues = JSON.parse(conditionalData.conditionalValue).toString()
				div.setAttribute('data-valid-values', formattedValues)
				div.setAttribute('data-conditional', conditionalData.conditionalParent)
			}

			if (this.editableRef) div.classList.add('multiple-references')
			formElementCreator({
				'container': div,
				'element': options.element,
				'currentLanguage': options.currentLang,
				'callback': this.allElementsHaveBeenRendered.bind(this),
				'languages': this.languages,
				'editableRef': this.formIsEditableReference,
				'editableRefInt': this.editableRefInt,
				'entity': this.entity,
				'routeChangeSuccess': this.callback,
				'conditionalData': conditionalData,
				'addToConditionalDataArrCallback': this.addToConditionalDataArr.bind(this),
				'startUniform': this.startUniform,
				'instances': this.instances
			}).init()
			this.langWrapper.appendChild(div)
		},

		createHR: function () {
			var hr = document.createElement('hr')
			this.langWrapper.appendChild(hr)
		},

		addToConditionalDataArr: function (conditionalItem) {
			if (conditionalItem) this.conditionalDataArr.push(conditionalItem)
		},

		allElementsHaveBeenRendered: function (conditionalItem, name) {
			this.elementCounter++

			if (this.amountOfElements === this.elementCounter) {
				this.startUniform(this.callback)
			}
		}
	}
}

export default formCreator
